var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("h2", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.par.name + " - 查询")),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "space-between",
                  padding: "20px 0",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "start",
                    },
                  },
                  [
                    _c("span", { staticStyle: { width: "50px" } }, [
                      _vm._v("姓名："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "请输入姓名" },
                      model: {
                        value: _vm.pageFrom.empName,
                        callback: function ($$v) {
                          _vm.$set(_vm.pageFrom, "empName", $$v)
                        },
                        expression: "pageFrom.empName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "start",
                    },
                  },
                  [
                    _c("span", { staticStyle: { width: "60px" } }, [
                      _vm._v("手机号："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "请输入手机号" },
                      model: {
                        value: _vm.pageFrom.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.pageFrom, "phone", $$v)
                        },
                        expression: "pageFrom.phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "start",
                    },
                  },
                  [
                    _c("span", { staticStyle: { width: "50px" } }, [
                      _vm._v("部门："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "请输入部门" },
                      model: {
                        value: _vm.pageFrom.dept,
                        callback: function ($$v) {
                          _vm.$set(_vm.pageFrom, "dept", $$v)
                        },
                        expression: "pageFrom.dept",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "start",
                    },
                  },
                  [
                    _c("span", { staticStyle: { width: "50px" } }, [
                      _vm._v("状态："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择状态" },
                        model: {
                          value: _vm.pageFrom.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageFrom, "status", $$v)
                          },
                          expression: "pageFrom.status",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "启用", value: "1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "禁用", value: "0" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "start",
                    },
                  },
                  [
                    _c("span", { staticStyle: { width: "60px" } }, [
                      _vm._v("单位："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "180px" },
                        attrs: {
                          placeholder: "请选择单位",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.pageFrom.companyId,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageFrom, "companyId", $$v)
                          },
                          expression: "pageFrom.companyId",
                        },
                      },
                      _vm._l(_vm.companyOptions, function (item) {
                        return _c("el-option", {
                          key:
                            item.id ||
                            item.value ||
                            item.companyId ||
                            item.name,
                          attrs: {
                            label: item.name || item.label || item.companyName,
                            value: item.id || item.value || item.companyId,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "start",
                    },
                  },
                  [
                    _c("span", { staticStyle: { width: "50px" } }, [
                      _vm._v("标签："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: {
                          filterable: "",
                          remote: "",
                          "remote-method": _vm.handleTagSearch,
                          loading: _vm.tagLoading,
                          clearable: "",
                          placeholder: "请输入关键词搜索标签",
                        },
                        model: {
                          value: _vm.pageFrom.tagId,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageFrom, "tagId", $$v)
                          },
                          expression: "pageFrom.tagId",
                        },
                      },
                      _vm._l(_vm.tagOptions, function (item) {
                        return _c("el-option", {
                          key: item.tagId,
                          attrs: { label: item.tagName, value: item.tagId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "center",
                  padding: "20px 0",
                },
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.getList(1)
                      },
                    },
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "warning" },
                    on: {
                      click: function ($event) {
                        _vm.pageFrom.dept = ""
                        _vm.pageFrom.empName = ""
                        _vm.pageFrom.phone = ""
                        _vm.pageFrom.status = ""
                        _vm.pageFrom.companyId = ""
                        _vm.pageFrom.tagId = ""
                        _vm.getList()
                      },
                    },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.par.name + " - 员工管理")),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                gap: "0 10px",
                margin: "20px 0",
              },
            },
            [
              _c(
                "ButtonUploadExcel",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:customer:emp:import1"],
                      expression: "['admin:customer:emp:import1']",
                    },
                  ],
                  attrs: { onSuccess: _vm.onSuccess },
                },
                [_vm._v(" 导入员工 ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:customer:emp:export"],
                      expression: "['admin:customer:emp:export']",
                    },
                  ],
                  attrs: { type: "primary", label: "default" },
                  on: { click: _vm.downTemplate },
                },
                [_vm._v("下载模板")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:customer:emp:add"],
                      expression: "['admin:customer:emp:add']",
                    },
                  ],
                  attrs: { type: "primary", label: "default" },
                  on: { click: _vm.add },
                },
                [_vm._v("新增员工")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", label: "default" },
                  on: { click: _vm.export_emp },
                },
                [_vm._v("导出员工")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", label: "default" },
                  on: { click: _vm.export_emp_fudou_info },
                },
                [_vm._v("导出员工福豆信息")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:customer:emp:add"],
                      expression: "['admin:customer:emp:add']",
                    },
                  ],
                  attrs: {
                    type: "success",
                    disabled: !_vm.selectedEmployees.length,
                  },
                  on: { click: _vm.sendCouponPackages },
                },
                [_vm._v("\n        发送优惠券包\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "empNo", label: "工号", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "empName", label: "姓名", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "wechat", label: "微信号", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "companyName",
                  label: "单位",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dept", label: "部门", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "title", label: "职位", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "tagName", label: "标签", "min-width": "300" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "grantIntegral",
                  label: "发放剩余福豆",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "integral",
                  label: "总剩余福豆",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            "active-text": "启用",
                            "inactive-color": "#ff4949",
                            "inactive-text": "禁用",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.ChanageCpStatus(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "180", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customer:emp:update"],
                                expression: "['admin:customer:emp:update']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.edit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "page-sizes": [15, 30, 45, 60],
              "page-size": _vm.pageFrom.limit,
              "current-page": _vm.pageFrom.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.pageChange,
            },
          }),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "温馨提示: 员工设置为离职状态，不影响员工使用剩余积分，如果要员工不能使用积分，请回收员工剩余积分。"
            ),
          ]),
          _vm._v(" "),
          _c("AddVue", {
            ref: "AddVueRef",
            attrs: { "company-options": _vm.companyOptions },
            on: { refresh: _vm.getList },
          }),
          _vm._v(" "),
          _c("SendCouponPackage", {
            ref: "SendCouponPackageRef",
            on: { refresh: _vm.getList },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }